import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { RTL_LANGUAGES } from '../../config/i18n';
import {setDirection} from "../../store/actions/app-actions";
import {useSoftUIController} from "../../context";
import { GrLanguage } from "react-icons/gr";
import {useLocation, useNavigate} from "react-router-dom";
import PropTypes from "prop-types";

const LanguageSwitcher = ({color = "inherit"}) => {
    const { i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [controller, dispatch] = useSoftUIController();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageChange = (lang) => {
        const currentPath = pathname.split('/').slice(2).join('/');
        navigate(`/${lang}/${currentPath}`);
        i18n.changeLanguage(lang);
        setDirection(dispatch, RTL_LANGUAGES.includes(lang) ? "rtl" : "ltr");
        handleClose();
    };

    useEffect(() => {
        const newDir = RTL_LANGUAGES.includes(i18n.language) ? 'rtl' : 'ltr';
        setDirection(dispatch, newDir);
    }, [i18n.language, dispatch]);

    return (
        <div>
            <IconButton onClick={handleClick} color={color}>
                <GrLanguage size={25} />
            </IconButton>
            <span style={{fontSize:"14px", color:color}}>{i18n.language === "ar" ? "العربية" : "English"}</span>
            <Menu
                id="language-switcher-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                <MenuItem onClick={() => handleLanguageChange('en')} selected={i18n.language === 'en'}>English</MenuItem>
                <MenuItem onClick={() => handleLanguageChange('ar')} selected={i18n.language === 'ar'}>العربية</MenuItem>
            </Menu>
        </div>
    );
};
LanguageSwitcher.propTypes = {
    color: PropTypes.string
}


export default LanguageSwitcher;
